module.exports = __webpack_public_path__ + "static/img/28.c2d1a1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/ProcessAutomation/28.png
// module id = ITqo
// module chunks = 1